'use strict';

angular.module('shiftTraderApp')
  .directive('saPositionBar', function (WorkPeriodStore, PositioningService, saViewShiftRowHeightInt, $timeout,
                                        TimeService, EventStreamsService, $compile,
                                        zIndexManageWorkPeriodsMax,
                                        zIndexManageWorkPeriodsDeptInterval,
                                        zIndexManageWorkPeriodsPosInterval,
                                        Session, MWPHighlightService, saDrawShiftBarHeight) {

    var overlayBarTpl = '<div class="position_bar_hour_overlay_bar_wrapper">' +
      '<div class="position_bar_hour_overlay_bar collapsed">' +
        '<div class="position_bar_hour_overlay_interval"' +
          'data-ng-repeat="intervalObj in workIntervalsToDraw track by intervalObj.uniqueId"' +
          'data-ng-style="::intervalObj.styling"' +
          'data-ng-bind="::(intervalObj.showLabel ? intervalObj.count : \'\')">' +
        '</div>' +
      '</div>' +
    '</div>';


    return {
      templateUrl: 'views/directives/saPositionBar.html',
      restrict: 'A',
      require: '^saWideWorkPeriodView',
      scope: {
        position: '='
      },
      link: function(scope, elem, attrs, ctrl) {
        var stream = EventStreamsService.getStream(EventStreamsService.names.mwpUpdates);
        var barIntervalUpdateStream = EventStreamsService.getStream(EventStreamsService.names.barIntervalUpdates);
        var disposableSubscriptions = [];

        var positionBarStyles = {
          'min-height': saViewShiftRowHeightInt + 'px'
        };

        var nextShiftsAndWorkPeriods = [];
        var currentViewWindow = undefined;
        scope.currentDate = ctrl.getCurrentDate();
        var shifts = [];
        scope.currentShiftsAndWorkPeriods = [];

        var mwpPositionElem = $('#mwp-position-height-' + scope.position.id);

        var positionBarContainer = elem.find('.position_bar_container');

        var setPositionBarContainerStyle = function(dikt) {
          positionBarContainer.css(dikt);
          mwpPositionElem.css('height', dikt.height);
        };

        scope.drawShiftBarState = false;

        var theZIndex;

        var setupZIndex = function() {
          theZIndex = scope.position._zIndexStart;
          $(elem).find('.position_bar_hour_overlay_bar').css('z-index', theZIndex);
          $(elem).find('.sa_draw_shift_bar').css('z-index', theZIndex + 1);
        };

        setupZIndex();


        scope.getWorkPeriodsInCurrentDate = function() {
          // window.logTime('getWorkPeriodsInCurrentDate START: ' + scope.position.name);
          currentViewWindow = moment(scope.currentDate).subtract(6, 'hours').twix(moment(scope.currentDate).add(24 + 6, 'hours'));
          currentViewWindow.start.hour(18);
          currentViewWindow.end.hour(6);
          var workDayStart = TimeService.getBeginningOfDayFromDateWithOrgSetting(moment(scope.currentDate));
          var workDayTwix = workDayStart.twix(moment(workDayStart).add(1, 'days'));

          var shiftTemplate = ctrl.getSelectedTemplate();

          scope.workPeriods = lodash(ctrl.getWorkPeriodsOfTheDay())
            .filter({position_id: scope.position.id})
            .map(function(wp) {
              if (lodash.has(wp, 'shift_id') && !lodash.isUndefined(wp.shift_id) && !lodash.isNull(wp.shift_id)) {
                //console.log(wp);
                //console.log(shiftTemplate.shifts);
                wp._fromSelectedTemplate = (function() {
                  return !lodash.isUndefined(lodash.find(shiftTemplate.shifts, {id: wp.shift_id})) &&
                    (wp.start_time.isSame(workDayTwix.start) || workDayTwix.contains(wp.start_time)) && !workDayTwix.end.isSame(wp.start_time);
                })()
              } else {
                wp._fromSelectedTemplate = false;
              }
              return wp;
            }).value();

          // figure out which shifts should be remove from nextShiftsAndWorkPeriods because they are already filled
          var shiftsWithWorkPeriodsInActiveTemplate = shiftTemplate.id > -1 ? lodash.filter(scope.workPeriods, function(wp) {
            return lodash.some(nextShiftsAndWorkPeriods, function(shift) {
              return shift.id === wp.shift_id &&
                     (wp.start_time.isSame(workDayTwix.start) || workDayTwix.contains(wp.start_time)) && !workDayTwix.end.isSame(wp.start_time);
            });
          }) : [];

          var idx;
          lodash.forEach(shiftsWithWorkPeriodsInActiveTemplate, function(wp) {
            idx = lodash.findIndex(nextShiftsAndWorkPeriods, {id: wp.shift_id});
            if (idx > -1) {
              nextShiftsAndWorkPeriods.splice(idx, 1);
            }
          });

          lodash.forEach(scope.workPeriods, function(wp) {
            var idx = lodash.findIndex(nextShiftsAndWorkPeriods, {id: wp.id});

            if (idx > -1) {
              nextShiftsAndWorkPeriods[idx] = wp;
            } else {
              nextShiftsAndWorkPeriods.push(wp);
            }
          });

          // window.logTime('getWorkPeriodsInCurrentDate END: ' + scope.position.name);

          scope.calculateHeight();
          findAllWorkIntervals();
        };

        scope.getShiftsInCurrentDate = function() {
          //console.log('scope.getShiftsInCurrentDate');
          if (ctrl.getSelectedTemplate().id !== -1) {
            shifts = lodash(ctrl.getSelectedTemplate().shifts).filter(function(s) {
              // only show shifts from template w/ active position
              return s.position_id === scope.position.id && s.active && scope.position.active;
            }).map(function(s) {
              return s.$setDateForTimeCalcs(scope.currentDate);
            }).value();

            nextShiftsAndWorkPeriods.push.apply(nextShiftsAndWorkPeriods, shifts);
          } else {
            shifts = [];
          }
        };

        scope.$on('redrawPositionBar', function(event, data) {
          // window.logTime('redrawPositionBar $on ' + scope.position.id + ' ' + scope.position.name);
          var redraw = false;

          if (data === true) {
            redraw = true;
          } else if (lodash.has(data, 'currentDate')) {
            redraw = true;
          } else if (lodash.has(data, 'positionId')) {
            if (data.positionId === scope.position.id) {
              redraw = true;
            }
          }

          if (redraw) {
           // console.log('REDRAW IS TRUE');
            event.preventDefault();
            nextShiftsAndWorkPeriods = [];
            var lastCurrentDate = scope.currentDate;
            scope.currentDate = ctrl.getCurrentDate();
            scope.getShiftsInCurrentDate();
            scope.getWorkPeriodsInCurrentDate();

            // no need to send the events if there are no saIntelliViewShift's to respond
            if (scope.currentShiftsAndWorkPeriods.length > 0 && !lastCurrentDate.isSame(scope.currentDate, 'seconds')) {
              scope.$broadcast('mwpCurrentDateChange', scope.currentDate);
            }
            elem.removeClass('highlighted');

            //whenever the day changes re-init zIndex just in case the day created a
            //   different arrangement of positions/depts due to inactives coming back
            setupZIndex();
          }
        });

        function setCollapseState() {
          scope.calculateHeight();

          $timeout(function() {
            if (scope.position._collapsed) {
              $(elem).find('.position_bar_hour_overlay_bar_wrapper').remove();
              $(elem).find('.position_bar_container').append($compile(overlayBarTpl)(scope));
              $(elem).addClass('collapsed');
            } else {
              $(elem).find('.position_bar_hour_overlay_bar_wrapper').remove();
              $(elem).removeClass('collapsed');
            }
          }, 0);
        }

        var mwpCollapseStream = EventStreamsService.getStream(EventStreamsService.names.mwpCollapseChange);

        disposableSubscriptions.push(mwpCollapseStream.filterByType(['all', 'position']).subscribe(function(obj) {
          console.log('collapse change', obj);

          if (obj.type === 'all' || (obj.type === 'position' && obj.data === scope.position.id)) {
            Session.setManageWorkPeriodsCollapsePosState(scope.position.id, scope.position._collapsed);
            setCollapseState();
          }
        }));

        scope.$on('sa:manageWorkPeriod:repositionViewShifts', function(event, data) {
          var redraw = false;
          if (data === true) {
            redraw = true;
          } else if (lodash.includes(data, 'currentDate')) {
            redraw = true;
          } else if (lodash.includes(data, 'positionId')) {
            if (data.positionId === scope.position.id) {
              redraw = true;
            }
          }

          if (redraw) {
            console.log('$on positionViewShifts: ', scope.position.id, scope.position.name);
            scope.calculateHeight(true);
          }
        });


        scope.calculateHeight = function(useCurrent) {
          // window.logTime('calculateHeight START: ' + scope.position.name);
          var collection = nextShiftsAndWorkPeriods;
          if (useCurrent) {
            collection = scope.currentShiftsAndWorkPeriods;
          }

          collection = lodash.sortBy(collection, function(wps) {
            if (wps.editingTwix) {
              return wps.editingTwix.start.unix();
            } else {
              return wps.range_twix.start.unix();
            }
          });

          var positioningResults = PositioningService.calcWorkPeriodShiftRow(collection);
          lodash.forEach(positioningResults.rows, function(row, idx) {
            collection[idx]._expandedTop = (scope.drawShiftBarState ? saDrawShiftBarHeight : 0) + row * saViewShiftRowHeightInt;
          });

          if (scope.position._collapsed) {
            scope.position._height = saViewShiftRowHeightInt;
          } else {
            if (scope.drawShiftBarState) {
              scope.position._height = lodash.max([saViewShiftRowHeightInt * 2.5, (positioningResults.numRows * saViewShiftRowHeightInt + saDrawShiftBarHeight)]);
            } else {
              scope.position._height = positioningResults.numRows > 2 ? positioningResults.numRows * saViewShiftRowHeightInt : saViewShiftRowHeightInt * 2.5;
            }
          }

          positionBarStyles.height = scope.position._height + 'px';
          setPositionBarContainerStyle(positionBarStyles);
          // make the new shiftsAndWorkPeriods live on the screen
          scope.currentShiftsAndWorkPeriods = lodash.clone(collection);
          // window.logTime('calculateHeight END: ' + scope.position.name);

          stream.push('shiftTopUpdate', true);

          scope.$emit('reloadingPositionBar');
        };


        var positionEndpointCalc = function(wpsCollection, viewTwix, viewTwixLength) {
          return lodash([0, viewTwixLength, lodash.map(wpsCollection, function(wps) {
            var temp;
            var res = [];
//            console.log(viewTwix.format());
//            console.log(viewTwixLength);
//            console.log(viewTwix.start.twix(wps.start_time).format());
//            console.log(viewTwix.start.format());
//            console.log(wps.start_time.format());
//            console.log(viewTwix.start.isDST(), viewTwix.end.isDST());


            temp = viewTwix.start.twix(wps.start_time).length('minutes');

            if (viewTwix.start._offset !== wps.range_twix.start._offset) {
//              console.log(viewTwix.start._offset, wps.range_twix.start._offset);
              temp = temp + (viewTwix.start._offset - wps.range_twix.start._offset);
            }

            res.push(temp > 0 ? lodash.clone(temp) : 0);
            temp = viewTwix.start.twix(wps.end_time).length('minutes');

            if (viewTwix.start._offset !== wps.range_twix.end._offset) {
//              console.log(viewTwix.start._offset, wps.range_twix.end._offset);
              temp = temp + (viewTwix.start._offset - wps.range_twix.end._offset);
            }

            res.push(temp > viewTwixLength ? viewTwixLength : temp);
//            console.log(res);
            return res;
          })]).flattenDeep().uniq().sortBy().value();
        };

        var positionTestFn = function(dikt, wpsCollection, viewTwix) {
          var testPoint = moment(viewTwix.start).add(dikt.interval[0] + 1, 'minutes');
          dikt.count = lodash.filter(wpsCollection, function(wp) {
            return wp.range_twix.contains(testPoint);
          }).length;
        };

        var positionStyleFn = function(dikt, idx, previousDikt, maxCount) {
          if (idx > 0 && dikt.count > 0 && previousDikt.count > 0) {
            dikt.styling['border-left'] = 'none';
          }

          dikt.uniqueId = dikt.styling.left + '-' + dikt.styling.width + '-' + dikt.count;
          //dikt.styling['background-color'] = 'rgba(68,98,98,' + (Math.pow(2, 0.92 * (dikt.count / maxCount)) - 0.8) + ')';
        };

        var findAllWorkIntervals = function() {
          // window.logTime('findAllWorkIntervals START: ' + scope.position.name);
          var allWorkIntervals = PositioningService.calcWorkIntervals(scope.workPeriods,
              currentViewWindow,
              positionEndpointCalc, positionTestFn, positionStyleFn);

          barIntervalUpdateStream.push('positionUpdate',
            {
              intervals: allWorkIntervals,
              position_id: scope.position.id,
              department_id: scope.position.department_id
            }
          );

          scope.workIntervalsToDraw = lodash.filter(allWorkIntervals, function(interval) {
            return interval.count > 0;
          });
          // window.logTime('findAllWorkIntervals END: ' + scope.position.name);
        };

        var setupHighlights = function() {
          var highlight = MWPHighlightService.getCurrentHighlight();
          // console.log('positionBar: ', scope.position.id, highlight);

          if (highlight) {
            var currentWorkPeriodIds = lodash(scope.currentShiftsAndWorkPeriods).filter({_type: 'workPeriod'}).map('id').value();


            //console.log(currentWorkPeriodIds);
            if (lodash.some(highlight.workPeriodIds, function(wpId) {
                return lodash.includes(currentWorkPeriodIds, wpId);
              })) {
              //console.log('saPositionBar: ', scope.position.id, 'found something to highlight');
              elem.addClass('highlighted');

              $timeout(function() {
                var element = $(elem);
                lodash.forEach(highlight.workPeriodIds, function(wpId) {
                  element.find('#wp-' + wpId).addClass('highlighted');
                });
              }, 400);

              $timeout(function() {
                var element = $(elem);
                elem.removeClass('highlighted');

                lodash.forEach(highlight.workPeriodIds, function(wpId) {
                  element.find('#wp-' + wpId).removeClass('highlighted');
                });
              }, 7000);
            }
          }
        };

        scope.$on('sa:manageWorkPeriod:highlightWorkPeriods', function() {
          //console.log('$on: sa:manageWorkPeriod:highlightWorkPeriods');
          setupHighlights();
        });

        scope.getShiftsInCurrentDate();
        scope.getWorkPeriodsInCurrentDate();

        scope.$on('sa:manageWorkPeriods:setEditDrawMode', function(event, val) {
          scope.drawShiftBarState = val;
          scope.calculateHeight(true);
        });

        setCollapseState();

        scope.$on('$destroy', function() {
          lodash.invoke(disposableSubscriptions, 'dispose');
        });
      },
      controller: ['$scope', function($scope) {
        this.getPositionZIndexStart = function() {
          return $scope.position._zIndexStart;
        };
      }]
    };
  });
